









































































import { SignInForm } from "@/types";
import Vue from "vue";
import { mapActions } from "vuex";

export default Vue.extend({
  data(): SignInForm {
    return {
      email: null,
      password: null,
      rememberMe: false,
    };
  },
  computed: {
    isValidForm(): boolean {
      return this.email != null && this.password != null;
    },
  },
  components: {
    AuthInput: () => import("./components/AuthInput.vue"),
  },
  methods: {
    ...mapActions("authService", ["postLogin"]),
    async sendRequest(e?: Event) {
      if (e) e.preventDefault();
      await this.postLogin({
        email: this.email,
        password: this.password,
        rememberMe: this.rememberMe,
      }).then(() => {
        setTimeout(() => {
          this.$router.push({ name: "Dashboard" });
        }, 200);
      });
    },
  },
  // mounted() {},
});
